import IdentificationError from './IdentificationError';
class IdentificationTypeIsUnsupported extends IdentificationError {
    constructor(options) {
        super('Identification type is unsupported', options);
    }
}
export default IdentificationTypeIsUnsupported;
